import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const useReportOptions = () => {
  const {t} = useTranslation();

  const SIMULATIONS_REPORT_OPTIONS = useMemo(
    () => [
      {id: 0, name: t("report_options.avatar_not_visible")},
      {id: 1, name: t("report_options.avatar_silent")},
      {id: 2, name: t("report_options.avatar_frozen")},
      {id: 3, name: t("report_options.record_button_not_working")},
      {id: 4, name: t("report_options.browser_not_asked_for_permission")},
      {id: 5, name: t("report_options.voice_not_recognized")},
      {id: 6, name: t("report_options.voice_not_recognized_first_time")},
      {id: 7, name: t("report_options.voice_recognized_but_no_response")},
      {id: 8, name: t("report_options.voice_recorded_but_no_response")},
      {id: 9, name: t("report_options.voice_response_not_relevant")},
      {id: 9, name: t("report_options.conversation_interrupted")},
      {id: 11, name: t("report_options.finish_button_not_working")},
      {id: 12, name: t("report_options.score_form_not_appeared")},
      {id: 13, name: t("report_options.other_problem")},
    ],
    [t],
  );

  const USER_REPORT_OPTIONS = useMemo(
    () => [
      {id: 0, name: t("report_options.country")},
      {id: 1, name: t("report_options.region")},
    ],
    [t],
  );

  return {
    SIMULATIONS_REPORT_OPTIONS,
    USER_REPORT_OPTIONS,
  };
};
